﻿const History = window.History; // Note: We are using a capital H instead of a lower h
let compareListSortBy;
let compareListSortDesc;

function getData() {
    const sortBy = compareListSortBy;
    const sortDesc = compareListSortDesc;
    return {
        SortBy: sortBy,
        SortDesc: sortDesc
    };
}

function buildUpQueryString(data) {
    let queryString = "";

    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;

    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;

    return "?" + queryString;
}

function sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data('air-index-compare-list-sort');
    if (compareListSortBy !== newSortBy) {
        compareListSortDesc = "false";
    } else {
        compareListSortDesc = "true";
    }
    compareListSortBy = newSortBy;
    const data = getData();
    History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
}

export function setupAirIndexCompareList() {
    if (!$('[data-air-index-compare-list]').length) {
        return;
    }
    compareListSortBy = $('#SortBy').val();
    compareListSortDesc = $('#SortDesc').val();
    $(document).on("click", "[data-air-index-compare-list-sort]", sortResults);
    $(`[data-air-index-compare-list-sort=${compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
    if (compareListSortDesc.toLowerCase() === "true") {
        $("[data-air-index-compare-list-sort=" + compareListSortBy + "]").attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
    }
    $(document).on("click", "[data-air-index-remove-from-list]", function (event) {
        const id = $(this).attr("data-air-index-remove-from-list");
        $.get("/emissions-data/compare-list/handle/remove/" + id, function (response) {
        });
    });
    History.Adapter.bind(window, 'statechange', function () { // Note: We are using statechange instead of popstate#
        const State = History.getState();
        $.get('/emissions-data/compare-list/results/' + $('#AirIndexVehicleIds').val(), State.data, function (response) {
            $('#compare-list-results-container').replaceWith(response);

            $(`[data-air-index-compare-list-sort=${compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
            if (compareListSortDesc.toLowerCase() === "true") {
                $("[data-compare-list-sort=" + compareListSortBy + "]").attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
            }
        });
    });
}